module.exports = __webpack_public_path__ + "img/sp-popup-bg.92b2afad.png";